import { styled } from "@mui/system";
import { Typography, Button, Container } from "@mui/material";
import { specialFont } from "../../../Infrastructure/Theme/fontFamily";

export const sectionNotFoundSx = {
  root: {
      height: '60vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      textAlign: 'center',
      px: 2
    },
    textOne: { fontFamily: specialFont, fontSize: "22px" },
    textTwo: { mt: 1 }

}
export const ErrorContainer = styled(Container)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
  }));
  
 export  const ErrorCode = styled(Typography)(({ theme }) => ({
    fontSize: "4rem",
  }));
  
 export  const ErrorMessage = styled(Typography)(({ theme }) => ({
    fontSize: "0.9rem",
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  }));
  
 export  const HomeButton = styled(Button)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  }));